import styles from "./broadcast-message.module.less";
import { multipleClassNames, Icon } from "@parksandresorts/core";
import LinkWrapper from "components/block-elements/link-wrapper/link-wrapper";
import { ContentfulContentPageProps } from "templates/content-page";

export type BroadcastMessageProps = Pick<
  ContentfulContentPageProps["data"]["contentfulSiteConfiguration"],
  "broadcastMessageContent" | "broadcastMessageStatus" | "broadcastMessageLink"
>;

export const handleBroadcastMessageStatus = ({
  broadcastMessageStatus,
}: Pick<BroadcastMessageProps, "broadcastMessageStatus">) => {
  const status = (() => {
    switch (broadcastMessageStatus) {
      case "Hide":
        return "hide";
      case "General info":
        return "general";
      case "Important info":
        return "important";
      case "Critical info":
        return "critical";
      default:
        return "hide";
    }
  })();
  return { status, shouldShow: status !== "hide" } as const;
};

const BroadcastMessage = ({
  broadcastMessageContent,
  broadcastMessageStatus,
  broadcastMessageLink,
}: BroadcastMessageProps) => {
  const broadcastMessageContentHtml = broadcastMessageContent?.childMarkdownRemark?.html;
  const link = broadcastMessageLink?.internalLink?.slug || broadcastMessageLink?.externalUrl;
  const linkTitle = broadcastMessageLink?.title;
  const linkSmallDeviceTitle = broadcastMessageLink?.smallDeviceTitle;

  const { status, shouldShow } = handleBroadcastMessageStatus({ broadcastMessageStatus });

  if (!shouldShow) return null;

  return (
    <LinkWrapper url={link}>
      <div className={multipleClassNames(styles.wrapper, link ? styles.link : "", styles[status])}>
        <div className="block--max-width">
          <div className={styles.content} dangerouslySetInnerHTML={{ __html: broadcastMessageContentHtml }} />
          <div className={styles.linkButton}>
            {link && linkTitle && (
              <span className={multipleClassNames(styles.linkTitle, "p_primary")}>{linkTitle}</span>
            )}
            {link && linkSmallDeviceTitle && (
              <span className={multipleClassNames(styles.linkSmallDeviceTitle, "body-s")}>{linkSmallDeviceTitle}</span>
            )}
            {link && <Icon name="chevron-right" size="xxs" />}
          </div>
        </div>
      </div>
    </LinkWrapper>
  );
};

export default BroadcastMessage;
